export const goalsContent = {
  hero: {
    title: "The Seeds We're Planting",
    subtitle: "This movement grows in phases. Here's where we're going—and what your support makes possible.\n\nPHASE 1: BUILD THE MOVEMENT ← WE ARE HERE. Growing the founding community through the Sacred Soil Alphabet and direct connection.\n\nPHASE 2: CREATE CERTIFICATION — NEXT. Developing certification standards to shift market demand toward soil health.\n\nPHASE 3: SUPPORT & LOOP — FUTURE. Directing economic flow back to the soil through a regenerative loops."
  },
  seeds: [
    {
      id: 1,
      title: "Art of Spelling",
      quote: "An open dialog to reconnect people to their magic.",
      description: "A ceremony framework for intentional language. In-person gatherings where people use the ERB Alphabet to release what no longer serves and call in what wants to grow.",
      whatItBecomes: ["Live ceremony events and retreats", "Facilitator training for community leaders", "A replicable ritual for communities everywhere"],
      image: "https://images.unsplash.com/photo-1544377193-33dcf4d68fb5?auto=format&fit=crop&q=80&w=800"
    },
    {
      id: 2,
      title: "Alphabet Soup for the Soil",
      quote: "Make bone broth with the skeletons in your closet.",
      description: "A transformation methodology rooted in nature's composting wisdom. The practice of cooking your past into nourishment for your future.",
      whatItBecomes: ["Guided content series on transformation", "Workshops pairing inner work with soil education", "A philosophy bridge connecting therapy and ecology"],
      image: "https://images.unsplash.com/photo-1547592166-23ac45744acd?auto=format&fit=crop&q=80&w=800"
    },
    {
      id: 3,
      title: "Kepri Scarab",
      quote: "Rise like the soil's rose.",
      description: "Our philosophical anchor. The ancient Egyptians encoded a profound truth in the humble dung beetle: transformation requires working with the filth, not avoiding it.",
      whatItBecomes: ["Metaphysics of soil education", "Symbol system and merchandise honoring scarab wisdom", "Partnerships bridging ancient knowledge and modern regeneration"],
      image: "https://images.unsplash.com/photo-1603566023894-39f2803b9059?auto=format&fit=crop&q=80&w=800"
    },
    {
      id: 4,
      title: "Certification",
      quote: "Is it food? Or is it anti-food?",
      description: "A simple question that cuts through the noise. ERB Certification will simplify the choice—a mark that tells consumers and locations: this respects the soil.",
      whatItBecomes: ["Certification standards for businesses and products", "A recognizable badge for net-positive soil impact", "Consumer education to shift market demand"],
      image: "https://images.unsplash.com/photo-1550989460-0adf9ea622e2?auto=format&fit=crop&q=80&w=800"
    },
    {
      id: 5,
      title: "Path of Proceeds",
      quote: "The earth is the ground—you provide the liquidity.",
      description: "Full transparency on where money flows. Every purchase powers regenerative land management and consumer education.",
      whatItBecomes: ["Transparent funding with public reporting", "Direct investment in regenerative projects", "A replicable framework for soil-centric business"],
      image: "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?auto=format&fit=crop&q=80&w=800"
    },
    {
      id: 6,
      title: "Community",
      quote: "Shared frequency of abundance and reverence for life.",
      description: "Not a company. A frequency. A decentralized gathering of consumers, producers, and land stewards who share one central truth: the soil is sacred.",
      whatItBecomes: ["Governance structure for aligned participants", "A network connecting certified locations", "Collaborative ventures across industries"],
      image: "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?auto=format&fit=crop&q=80&w=800"
    }
  ],
  closing: "Your Purchase Plants the Seed"
};